/**
 * A global namespace for `beforeunload` event.
 */
const beforeunloadEvent = 'beforeunload';
export default beforeunloadEvent;
